//TODO: Add all page titles
export const TITLES = {
  UPLOADED_FILES: 'Uploaded Files',
  DASHBOARD: 'Dashboard',
  STATEMENT: 'Statement',
  PORTFOLIO_SUMMARY: 'Portfolio Summary',
  TRANSACTION: 'Transaction',
  DAILY_EXPOSURE: 'Daily Exposure',
  COMMISSION_REBATE: 'Commission Rebate',
  SALES_TRADING: 'Sales Trading',
  SALES_TRADING_NEW: 'Sales Trading New',
  TURNOVER_BY_REGION: 'Turnover By Region',
  ICAV_REPORT: 'ICAV Report',
  OPEN_POSITION: 'Open Positions',
  TRADE_BLOTTER: 'Trade Blotter',
  CLIENTS: 'Clients',
  TRADERS: 'Traders',
  MARKETS: 'Markets',
  SECURITIES_DICTIONARY: 'Securities',
  EXCHANGES: 'Exchanges',
  CLIENT_GROUPS: 'Client Groups',
  CREATE_CLIENT: 'Create a Client',
  CREATE_BROKER: 'Create a Broker',
  PRODUCT_PRICING: 'Product Pricing',
  CLIENT_UNIT_SIZE: 'Client Unit Size',
  CUSTODY_DATA: 'Custody Data',
  CUSTODY_DATA_CASH: 'Custody Cash',
  CUSTODY_DATA_CONFIGURATION: 'Configuration',
  CUSTODY_DATA_CONFIGURATION_MANUAL: 'Manual Configuration',
  CUSTODY_IMPORT_FILES: 'Custody Import Files',
  CUSTODY_DATA_POSITIONS: 'Custody Positions',
  CUSTODY_DATA_RUN: 'Run',
  CUSTODY_DATA_TRANSACTIONS: 'Custody Transactions',
  TRADE_PARAMETER_VALUE_ID: 'Parameter Value ID',
  EXTERNAL_CONTACTS: 'External Contacts',
  TRADE_SEARCH: 'Search Trade',
  TRADE_ENTRY: 'Trade Entry',
  TRADE_CORPORATE: 'Corporate Actions',
  TRADE_CONFIRMATION: 'Trade Confirmation',
  TRADE_CONFIRMATION_SEARCH: 'Confirmation Search',
  TRADE_ALLOCATION: 'Trade Allocation',
  TRADE_MARGINPROCESSING: 'Margin Processing',
  FEES_BOOKING: 'Fees Booking',
  IMPORT_FILES: 'Import Files',
  RECONCILIATION: 'Reconciliation',
  COUNTERPARTY_POSITIONS: 'Counterparty Positions',
  RECALCULATION: 'Recalculation',
  FIX_ENGINE: 'Fix Engine',
  TRADE_HOLIDAY: 'Settlement Holiday',
  REBALANCE: 'Rebalance',
  ACGMarkup: 'ACG Markup',
  BROKERS: 'Brokers',
  MIFID_II_FILE: 'Create MIFID II File',
  PAIR_TRADING: 'Pair Trading',
  DOCUMENTATION: 'Documentation',
  REGIONS: 'Regions',
  ACCOUNT_SUMMARY: 'Account Summary',
  FACTSHEET_CREATE: 'Create a Factsheet',
  CHECK_QUANTITIES: 'Check Quantities',
  LOGIN: 'Log in',
  VIRTU: 'Virtu',
  GOLDMAN_SACHS: 'Goldman Sachs',
  TRADERS_PL: 'Traders P&L',
  TIMELINE: 'Timeline',
  RSI_PATTERN_RECOGNITION: 'RSI Pattern Recognition',
  RSI_HISTORY: 'RSI History',
  PORTFOLIOS: 'Portfolios',
  PORTFOLIO_DETAILS: 'Portfolio Details',
  //Admin
  USER_MANAGEMENT_USERS: 'Users',
  USER_MANAGEMENT_TABS: 'Tabs',
  USER_MANAGEMENT_PERMISSIONS: 'Permissions',
  USER_MANAGEMENT_GROUPS: 'Groups',

  CONFIGURATION_PARAMETER: 'Parameter',
  CONFIGURATION_PARAMETER_VALUE_ID: 'Parameter Value ID',

  TOOLS_ACTIVITY_LOGS: 'Activity Logs',
  TOOLS_FAILED_FIX_MESSAGES: 'Failed Fix Messages',
  TOOLS_BACKUPS: 'Backups',
  TOOLS_FIX_AGGREGATION: 'Fix Aggregation',
  TOOLS_INSERT_FIX_MESSAGES: 'Insert Fix Messages',
  TOOLS_POSITIONS_RECALCULATION: 'Positions Recalculation',

  FILE_MANAGEMENT_SFTP: 'SFTP',

  FILE_MANAGEMENT_FILES_MAPPING: 'Files Mapping',

  SYSTEM_CONSTANTS: 'Constants',
  SYSTEM_MAINTENANCE: 'Maintenance',
  CONFIGURATION_SETTLEMENT_CYCLES: 'Settlement Cycles',

  NOTIFICATIONS: 'In-App Messages',
};
